<form id="ddiForm" [formGroup]="ddiFormGroup" class="grid">
  <div class="input-field col-12 md:col-6">
    <label>Nombre *</label>
    <input pInputText formControlName="name" class="w-full" />
  </div>
  <div class="input-field col-12 md:col-6">
    <label>Teléfono *</label>
    <input pInputText formControlName="phoneNumber" class="w-full" />
  </div>
  <div class="input-field col-12 md:col-6">
    <label>Plan de llamada</label>
    <p-dropdown [options]="dialPlans" formControlName="dialPlanId" optionLabel="name" optionValue="id"
      placeholder="— Sin plan —" appendTo="body" showClear [filter]="true" filterBy="name"
      styleClass="w-full"></p-dropdown>
  </div>
  <div class="input-field col-12 md:col-6 flex align-items-center gap-2 mt-4">
    <p-inputSwitch formControlName="active"></p-inputSwitch>
    <label class="mb-0">Activo</label>
  </div>
  <div class="input-field col-12 md:col-6">
    <label>Nombre de cola</label>
    <input pInputText formControlName="queueName" class="w-full" />
  </div>
  <div class="input-field col-12 md:col-6">
    <label>Tiempo de espera de cola (s)</label>
    <input type="number" pInputText formControlName="queueWaitTime" class="w-full" />
  </div>
</form>

<div class="flex justify-content-end gap-2 mt-4">
  <p-button label="Cancelar" severity="secondary" (click)="cancel()"></p-button>
  <p-button label="Guardar" icon="pi pi-save" (click)="save()" [loading]="saving"></p-button>
</div>
